// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import store from './store'
import '@/assets/styles/common.scss'
import '@/assets/styles/reset.scss'
import '@/assets/styles/iframe.scss'
import './assets/icon/iconfont.css'
import router from './router'
import utils from 'utils/utils'
import Query from 'base/query'
import Table from 'base/table'
import Form from 'base/form'
import Phone from 'base/phone'
import Tinymce from 'base/tinymce'
import SwipeCard from 'base/swipe-card'
import VueAMap from 'vue-amap'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import xlsx from 'xlsx'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAMap)
Vue.use(GeminiScrollbar)
Vue.use(xlsx)

Vue.prototype.$axios = axios

Vue.component(Query.name, Query)
Vue.component(Table.name, Table)
Vue.component(Form.name, Form)
Vue.component(Phone.name, Phone)
Vue.component(Tinymce.name, Tinymce)
Vue.component(SwipeCard.name, SwipeCard)
Vue.component('tween-num', require('vue-tween-number'))

Object.assign(Vue.prototype, utils)
Vue.prototype.$mailUrl = process.env.MAIL_URL

VueAMap.initAMapApiLoader({
  // 高德的key
  key: 'f5d0ceb38ab18f5033853642e8c1f29d',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js